import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { infCTesInterface, infProdutoPerigosoInterface } from "../../../../interfaces";
import { useState } from "react";
import { JConfirmDelete, MensagemModal } from "../../../../components/Components";
import { getUuidV4 } from "../../../../utils/utils";

interface formProps {
    notaFiscal: infCTesInterface;
    setNotaFiscal: React.Dispatch<React.SetStateAction<infCTesInterface>>
}

const initialForm: infProdutoPerigosoInterface = {
    id: 0,
    nONU: '',
    xNomeAE: '',
    xClaRisco: '',
    grEmb: '',
    qTotProd: '',
    qVolTipo: ''
}

const CTesProdutoPerigoso: React.FC<formProps> = ({ notaFiscal, setNotaFiscal }) => {
    const [form, setForm] = useState<infProdutoPerigosoInterface>(initialForm);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<number | string>(0);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(0);
    }

    const handleOpenModal = (id: number | string) => {
        setSelected(id);
        setShowModal(true);
    }

    const validaPreenchimento = () => {
        if (form.nONU.trim() === "") {
            alerta('Informe o número ONU/UN.')
            return false;
        }
        if (!/[0-9]{4}|ND/.test(form.nONU)) {
            alerta('Número ONU/UN deve conter 4 números ou ND.')
            return false;
        }

        if (form.qTotProd.trim() === "") {
            alerta('Informe a quantidade total por produto.')
            return false;
        }

        if (notaFiscal.chCTe.trim() === "") {
            alerta('Informe a chave da NF-e.')
            return false;
        }

        return true;
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            setNotaFiscal({
                ...notaFiscal,
                peri: [...notaFiscal.peri, {
                    ...form,
                    id: getUuidV4()
                }]
            })
            setForm(initialForm);
        }
    }

    const handleRemover = (id: number) => {
        if (notaFiscal.peri?.length > 0) {
            setNotaFiscal({
                ...notaFiscal,
                peri: notaFiscal.peri.filter(item => item.id !== id)
            })
        }
        setShowModal(false);
    }
    return (<>
        <Row className="mb-3 g-2">
            <Col md={3}>
                <Form.Group>
                    <Form.Label>Número ONU/UN</Form.Label>
                    <Form.Control name="nONU" maxLength={4} onChange={handleChange} value={form.nONU} />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>Nome Ap. Emb. Produto</Form.Label>
                    <Form.Control maxLength={150} name="xNomeAE" onChange={handleChange} value={form.xNomeAE} />
                </Form.Group>
            </Col>

        </Row>

        <Row className="mb-3 g-2">
            <Col md>
                <Form.Group>
                    <Form.Label>Classe de Risco</Form.Label>
                    <Form.Control maxLength={40} name="xClaRisco" onChange={handleChange} value={form.xClaRisco} />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>Grupo de Embalagem</Form.Label>
                    <Form.Control maxLength={6} name="grEmb" onChange={handleChange} value={form.grEmb} />
                </Form.Group>
            </Col>

        </Row>

        <Row className="mb-3 g-2">
            <Col md>
                <Form.Group>
                    <Form.Label>Qtd. Total por Produto</Form.Label>
                    <Form.Control maxLength={20} name="qTotProd" onChange={handleChange} value={form.qTotProd} />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>Qtd. e Tipo de Volumes</Form.Label>
                    <Form.Control maxLength={60} name="qVolTipo" onChange={handleChange} value={form.qVolTipo} />
                </Form.Group>
            </Col>

            <Col md={'auto'} className="d-flex align-items-end">
                <Button variant="primary" onClick={handleAdd} >
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </Button>
            </Col>

        </Row>

        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th className="text-center">#</th>
                    <th>Num ONU/UN</th>
                    <th>Classe Risco</th>
                    <th>Qtd. Total Produto</th>
                </tr>
            </thead>
            <tbody>

                {notaFiscal.peri?.map((item: infProdutoPerigosoInterface) => {
                    return (
                        <tr key={item.id}>
                            <td className="text-center">
                                <a href="#" className="text-danger" onClick={() => handleOpenModal(item.id)}>
                                    <i className="fas fa-trash"></i>
                                </a>
                            </td>
                            <td>{item.nONU}</td>
                            <td>{item.xClaRisco}</td>
                            <td>{item.qTotProd}</td>
                        </tr>
                    )
                })}

            </tbody>
        </Table>
        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={''}
            id={selected}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}
export default CTesProdutoPerigoso;